import ApiService from './api';

/**
 * CV Havuzu yanıt tipi
 */
interface CVPoolResponse {
  status: string;
  message: string;
}

/**
 * CV Havuzu için form veri tipi
 */
export interface CVFormData {
  name: string;
  email: string;
  profession: string;
  job_type: string; // 'job' veya 'internship'
  cv: File | null;
}

/**
 * CV Havuzu servis sınıfı
 */
export class CVPoolService {
  private static instance: CVPoolService;
  private apiService: ApiService;
  private baseUrl: string;

  /**
   * Özel constructor - singleton pattern
   */
  private constructor() {
    this.apiService = ApiService.getInstance();
       const config = useRuntimeConfig()
    this.baseUrl = config.public.NUXT_PUBLIC_BACKEND_BASE_URL || 'http://localhost:8080';
  }

  /**
   * Servis örneği al
   */
  public static getInstance(): CVPoolService {
    if (!CVPoolService.instance) {
      CVPoolService.instance = new CVPoolService();
    }
    return CVPoolService.instance;
  }

  /**
   * CV kaydı gönder
   * @param formData CV Havuzu form bilgileri
   */
  public async submitCV(formData: CVFormData): Promise<CVPoolResponse> {
    try {
      // FormData oluştur
      const form = new FormData();
      form.append('name', formData.name);
      form.append('email', formData.email);
      form.append('profession', formData.profession);
      form.append('job_type', formData.job_type);
      
      // Dosya ekleme
      if (formData.cv) {
        form.append('cv', formData.cv);
      }

      // API isteği
      const response = await fetch(`${this.baseUrl}/public/cv-pool`, {
        method: 'POST',
        body: form,
      });

      const data = await response.json();
      
      // Backend'den gelen yanıtı dönüştür
      return {
        status: response.status.toString(),
        message: data.message || 'CV başarıyla gönderildi.'
      };
    } catch (error) {
      console.error('CV gönderimi hatası:', error);
      return {
        status: 'error',
        message: 'CV gönderilirken bir hata oluştu.'
      };
    }
  }
} 